import api from "!../../../../.pnpm/style-loader@2.0.0_webpack@5.104.1/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../.pnpm/css-loader@5.2.7_webpack@5.104.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../../../.pnpm/resolve-url-loader@5.0.0/node_modules/resolve-url-loader/index.js!../../../../.pnpm/sass-loader@16.0.6_sass@1.97.2_webpack@5.104.1/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!./ui-loading.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};